<script>
export default {
  name: "ListItem",
  data(){
    return {
      show: false,
      selected: false,
      selectedId: ''
    }
  },
  props: ["item", "name", "handleSelect","preselect"],
  computed: {
    id(){
      return `item-${this.item.id}`;
    }
  },
  async mounted() {
    this.selectedId = this.preselect.id
  },
  methods: {
    handleClick(e) {
      if (e.target.checked){
        this.handleSelect(this.item)
      }
      this.show = !this.show;
      e.stopPropagation();
    },
  },
  watch: {
    selected() {
      console.log(this.selected);
    }
  }
}
</script>



<template>
  <div class="py-1 aaaaaaa" role="none">
    <div class="float-right mt-2 mr-2" v-if="item.children && item.children.length > 0">
       <!-- <svg
          class="-mr-1 ml-2 h-5 w-5"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 20 20"
          fill="currentColor"
          aria-hidden="true"
          v-if="show"
        >
          <path
            fill-rule="evenodd"
            d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
            clip-rule="evenodd"
          />
        </svg>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="h-5 w-5"
          viewBox="0 0 20 20"
          fill="currentColor"
          v-if="!show"
        >
          <path
            fill-rule="evenodd"
            d="M14.707 12.707a1 1 0 01-1.414 0L10 9.414l-3.293 3.293a1 1 0 01-1.414-1.414l4-4a1 1 0 011.414 0l4 4a1 1 0 010 1.414z"
            clip-rule="evenodd"
          />
        </svg> -->
    </div>
    <div class="text-gray-700 block px-4 text-sm " role="menuitem" tabindex="-1" :id="id">
      <label>
        
        
        <input :checked="item.id == selectedId ? 'checked' : ''" :disabled="item.disabled" type="radio" name="name" :value="item.id" class="mr-2" @click="handleClick"/>
        <span 
          :class="{ 'disabled-input': item.disabled }"
        >{{item.label}}</span>
        <span v-if="item.children && item.children.length > 0">
          <i v-if="!show" :class="{ 'disabled-input': item.disabled }" aria-hidden="true" class="v-icon notranslate mdi mdi-menu-down theme--light svg-arrow"></i>
          <i v-if="show" aria-hidden="true" class="v-icon notranslate mdi mdi-menu-up theme--light svg-arrow"></i>
        </span>
      </label>
    </div>
    <div class="pl-2 sub-item-li" v-if="show">
      <list-item v-for="children in item.children" :key="children.id" :item="children" :handle-select="handleSelect"></list-item>
    </div>
  </div>
</template>


<style scoped>
.disabled-input{
  color: gray;
}
.svg-arrow{
  display: inline-block;
  max-width: 20px;
  float: right;
}

.sub-item-li{
  margin-left: 10px;
}

label{
  width: 100%;
}
input[type="radio"] + label span {
  transition: background .2s,
  transform .2s;
}

input[type="radio"] + label span:hover,
input[type="radio"] + label:hover span{
  transform: scale(1.2);
} 

input[type="radio"]:checked + label span {
  background-color: #3490DC;
  box-shadow: 0px 0px 0px 2px white inset;
}

input[type="radio"]:checked + label{
   color: #3490DC;
}

</style>